import { track } from '@eventbrite/datalayer-library';
import { gettext } from '@eventbrite/i18n';
import React, { useEffect } from 'react';
import { LISTING_HEAP_IDS } from '../../../constants';
import { useGetListingsMobileEventCard } from '../../../experimentation/experiments';

import { RelatedEventsSection } from '../RelatedEventsSection';
import {
    OtherEventsYouMayLikeContent,
    OtherEventsYouMayLikeContentProps,
} from './OtherEventsYouMayLikeContent';

export type OtherEventsYouMayLikeProps = OtherEventsYouMayLikeContentProps;

//TODO remove calculateTopOffset once Listings Horizontal Other Events You May Like Experiment has finished
export const calculateTopOffset = () => {
    let isMobile = false;
    if (typeof window !== 'undefined') {
        isMobile = window?.innerWidth <= 480;
    }
    return isMobile;
};

export function OtherEventsYouMayLike({
    eventId,
    shareComponentProps,
    isAuthenticated,
    areMetricsEnabled,
    eventsToRemove,
    locale,
}: OtherEventsYouMayLikeProps) {
    const isMobile = calculateTopOffset();
    const isMobileListingsExperiment = useGetListingsMobileEventCard(isMobile);

    useEffect(() => {
        //see for multiticket
        track({
            eventName: LISTING_HEAP_IDS.RECCOMENDATIONS_VIEW,
            eventData: {
                eventBucketLabel: 'Other Events you may like',
            },
        });
    }, []);
    const CAROUSEL_HEADING = gettext('Other events you may like');
    return (
        <RelatedEventsSection
            className="listings-root__related-events"
            title={gettext('Other events you may like')}
            isMobileListingsExperiment={isMobileListingsExperiment}
        >
            <OtherEventsYouMayLikeContent
                eventId={eventId}
                isAuthenticated={isAuthenticated}
                shareComponentProps={shareComponentProps}
                areMetricsEnabled={areMetricsEnabled}
                eventsToRemove={eventsToRemove}
                locale={locale}
                bucketLabel={CAROUSEL_HEADING.toString()}
                isMobileListingsExperiment={isMobileListingsExperiment}
            />
        </RelatedEventsSection>
    );
}
